<template>
  <div class="distribution-posters">
    <navReturn></navReturn>
    <div class="slider-banner banner">
      <swiper class="swiper-wrapper" :options="swiperPosters" ref="mySwiper">
        <swiperSlide
          class="swiper-slide"
          v-for="(item, index) in info"
          :key="index"
        >
          <img class="slide-image" :src="item.wap_poster" />
        </swiperSlide>
      </swiper>
    </div>
    <!--<div class="keep bg-color-red" @click="saveImg">保存海报</div>-->
    <div class="preserve acea-row row-center-wrapper">
      <div class="line"></div>
      <div class="tip">Hold to save image</div>
      <div class="line"></div>
    </div>
    <div
      class="svg copy copy-data"
      @click="copy"
      v-if="info.length > 0"
      :data-clipboard-text="info[activeIndex].web_url"
    >
      <svg
        t="1583285910333"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="6223"
        width="128"
        height="128"
      >
        <path
          d="M509.44 38.912C249.856 38.912 39.936 249.344 39.936 508.416s209.92 469.504 469.504 469.504 469.504-210.432 469.504-469.504S768.512 38.912 509.44 38.912z m77.824 599.04l-110.08 110.08c-59.392 59.392-155.648 59.392-215.04 0s-59.392-155.648 0-215.04l41.984-41.984c6.656-7.168 16.384-12.288 27.136-13.312 22.528-2.048 41.984 14.848 44.032 37.376 1.024 13.312-4.608 26.112-13.824 34.304l0.512 0.512-40.96 40.96c-27.136 27.136-27.136 71.68 0 98.816s71.68 27.136 98.816 0l110.08-110.08c20.992-20.992 26.112-52.224 14.848-78.336-2.56-4.608-4.096-10.24-4.608-15.872-2.048-22.528 14.848-41.984 37.376-44.032 17.408-1.536 32.768 8.192 39.936 22.528v0.512c0.512 0.512 0.512 1.024 1.024 2.048 25.088 56.832 15.36 125.44-31.232 171.52z m175.104-165.376l-41.984 41.984c-6.656 7.168-16.384 12.288-27.136 13.312-22.528 2.048-41.984-14.848-44.032-37.376-1.024-13.312 4.608-26.112 13.824-34.304l-0.512-0.512 40.96-40.96c27.136-27.136 27.136-71.68 0-98.816s-71.68-27.136-98.816 0L495.104 425.472c-20.992 20.992-26.112 52.224-14.848 78.336 2.56 4.608 4.096 10.24 4.608 15.872 2.048 22.528-14.848 41.984-37.376 44.032-17.408 1.536-32.768-8.192-39.936-22.528v-0.512c-0.512-0.512-0.512-1.024-1.024-2.048-25.6-56.32-15.872-124.928 30.72-171.008l110.08-110.08c59.392-59.392 155.648-59.392 215.04 0 59.392 59.392 59.392 155.648 0 215.04z"
          p-id="6224"
          fill="#515151"
        ></path>
      </svg>
      <p>Copy Share Link</p>
    </div>
  </div>
</template>
<style>
.preserve {
  color: #fff;
  text-align: center;
  margin-top: 0.2rem;
}
.preserve .line {
  width: 1rem;
  height: 0.01rem;
  background-color: #fff;
}
.preserve .tip {
  margin: 0 0.3rem;
}
.svg {
  width: 80%;
  text-align: center;
  height: 1rem;
  border-top: 1px dashed #ccc;
  margin: 10px auto 0px auto;
  padding-top: 10px;
}
.svg svg {
  font-size: 30px;
}
</style>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import navReturn from "@components/navReturn";
import ClipboardJS from "clipboard";

import "@assets/css/swiper.min.css";
import { getSpreadImg } from "../../../api/user";
export default {
  name: "Poster",
  components: {
    swiper,
    swiperSlide,
    navReturn
  },
  props: {},
  data: function() {
    return {
      swiperPosters: {
        speed: 1000,
        effect: "coverflow",
        slidesPerView: "auto",
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0, // 旋转的角度
          stretch: -20, // 拉伸   图片间左右的间距和密集度
          depth: 100, // 深度   切换图片间上下的间距和密集度
          modifier: 3, // 修正值 该值越大前面的效果越明显
          slideShadows: false // 页面阴影效果
        },
        observer: true,
        observeParents: true
      },
      info: [],
      activeIndex: 0
    };
  },
  mounted: function() {
    this.getIndex();
    let that = this;
    this.swiper.on("slideChange", function() {
      that.activeIndex = that.swiper.activeIndex;
    });
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    getIndex: function() {
      let that = this;
      getSpreadImg().then(
        res => {
          that.info = res.data;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    copy() {
      let copybtn = document.getElementsByClassName("copy-data");
      const clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", () => {
        this.$dialog.success("Copy success");
      });
    }
    // downloadIamge: function(imgsrc, name) {
    //   let image = new Image();
    //   image.setAttribute("crossOrigin", "anonymous");
    //   image.onload = function() {
    //     let canvas = document.createElement("canvas");
    //     canvas.width = image.width;
    //     canvas.height = image.height;
    //     let context = canvas.getContext("2d");
    //     context.drawImage(image, 0, 0, image.width, image.height);
    //     let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
    //     let a = document.createElement("a"); // 生成一个a元素
    //     let event = new MouseEvent("click"); // 创建一个单击事件
    //     a.download = name || "photo"; // 设置图片名称
    //     a.href = url; // 将生成的URL设置为a.href属性
    //     a.dispatchEvent(event); // 触发a的单击事件
    //   };
    //   image.src = imgsrc;
    // },
    // saveImg: function() {
    //   console.log(this.info[this.activeIndex].wap_poster);
    //   this.downloadIamge(
    //     this.info[this.activeIndex].wap_poster,
    //     "poster" + this.activeIndex
    //   );
    // }
  }
};
</script>
